import { render, staticRenderFns } from "./Denuncia.vue?vue&type=template&id=7eb6b3ec"
import script from "./Denuncia.vue?vue&type=script&lang=js"
export * from "./Denuncia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports